import React from "react";
import { createClasses, TransparentButton } from "@bloomberg/media-ui-core";
import styles from "./styles.module.css";

type FormHeaderProps = {
  onCancelClick: () => void;
  onDeleteClick?: () => void;
  title: string;
  showDelete: boolean;
};

export default function FormHeader(props: FormHeaderProps) {
  const { onCancelClick, onDeleteClick, title, showDelete = false } = props;

  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <TransparentButton
          className={styles.button}
          type="button"
          title="Cancel"
          onClick={onCancelClick}
        >
          <span className={styles.buttonText}>Cancel</span>
        </TransparentButton>
      </div>
      <h4 className={styles.title}>{title}</h4>
      <div className={styles.headerRight}>
        {showDelete && (
          <TransparentButton
            className={styles.button}
            type="button"
            title="Delete Watchlist"
            onClick={onDeleteClick}
          >
            <span className={createClasses([styles.buttonText, styles.delete])}>
              Delete
            </span>
          </TransparentButton>
        )}
      </div>
    </div>
  );
}
